<template>
		<div class="p-0">
			<router-link class="pull-right btnx m-2" :to="{ name: 'bank_account_create'}"><i class="os-icon os-icon-edit-1"></i> {{ t.bank_account.create_bank_account }}</router-link>
			<div class="head">
				<h2>{{ t.navigation.bank_accounts }}</h2>
			</div>
			<div class="alert alert-info" role="alert" v-if="accountLoad == 404">
				{{ t.error.notfound_content_list }}
			</div>
			<div class="alert alert-info" role="alert" v-else-if="accountLoad == 400">
				{{ t.forbidden.showNotPermitted }}
			</div>
			<div class="element-content px-5 pb-5" v-else-if="accountLoad == 200">
				<table class="table table-lightborder">
					<thead>
						<th>
							<td>
								{{ t.bank_account.account_owner }}
							</td>
							<td>
								{{ t.finance.currency }}
							</td>
							<td>
								{{ t.finance.bank }}
							</td>
						</th>
					</thead>
					<tbody>
					<tr>
						<td>
							Muhammed Can
						</td>
					</tr>
					</tbody>
				</table>
			</div>

			<div class="row p-3">
				<div class="col-12 text-left" v-for="bc in accounts">
					<ul class="list-group element-box mb-4 px-2">
						<li class="list-group-item"><strong>{{ t.finance.bank }}:</strong> {{ bc.bankName }} <router-link class="pull-right" :to="{ name: 'bank_account_edit', params: { id: bc.id } }"><i class="os-icon os-icon-pencil-1"></i> {{ t.edit }}</router-link></li>
						<li class="list-group-item"><strong>{{ t.finance.currency }}:</strong> {{ bc.currency }} ({{ bc.currencySymbol }})</li>
						<li class="list-group-item"><strong>{{ t.bank_account.account_owner }}:</strong> {{ bc.ownerName }} </li>
						<li class="list-group-item"><strong>{{ t.bank_account.iban }}:</strong> {{ bc.iban }} </li>
						<li class="list-group-item"><strong>{{ t.bank_account.identifier }}:</strong> {{ bc.identifier }}</li>
						<li class="list-group-item"><strong>{{ t.bank_account.swift }}:</strong> {{ bc.swiftCode }}</li>
					</ul>
				</div>
			</div>

			<paginate v-if="pagination" class="mx-3"
			          :page-count="pagination.pageCount"
			          :page-range="pagination.pageRange"
			          :force-page="(pagination.current-1)"
			          :initialPage="(pagination.current-1)"
			          :margin-pages="2"
			          :click-handler="onChangePage"
			          :prev-text="t.previous"
			          :next-text="t.next"
			          :container-class="'pagination float-right'"
			          :page-class="'page-item'"
			          :page-link-class="'page-link'"
			          :prev-class="'page-item'"
			          :prev-link-class="'page-link'"
			          :next-class="'page-item'"
			          :next-link-class="'page-link'"
			>
			</paginate>
			</div>
</template>

<script>

    import Paginate from 'vuejs-paginate'
    export default {
        name: 'bankAccountList',
	    components: { Paginate },
        data () {
            return {
                t: this.$root.t,
                session: session,
	            accounts: null,
	            accountLoad: 0,
	            pagination: null
            }
        },
        watch: {
            '$route.query'() {
                this.fetchBankAccounts();
            },
        },
	    mounted () {
            this.fetchBankAccounts();
	    },
	    methods:
	    {
            onChangePage (page) {
                this.pagination.current = page;
                this.$router.push({ query: {} });
                this.$router.push({ query: {page: page} });

                window.scroll(0, 0);
            },
	        fetchBankAccounts () {
                this.$bus.$emit('globalLoader', 1);

                this.$http.get(api+'api/v1/user/accounting/bankAccounts/'+this.session.uid, {
                    params: { page: this.$route.query.page,access_token: this.$root.oauth.accessToken }
                })
                    .then(response => {

                        this.accounts = response.body.result.accounts;

                        this.accountLoad = response.body.code;
                        this.pagination = response.body.pagination;

                        this.$bus.$emit('globalLoader', 0);
                    }, response => {

                        this.accountLoad = response.body.code;

                        this.$bus.$emit('globalLoader', 0);
                    })
	        }
	    }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	.list-group {
		display: -webkit-box;
		display: -ms-flexbox;
		display: flex;
		-webkit-box-orient: vertical;
		-webkit-box-direction: normal;
		-ms-flex-direction: column;
		flex-direction: column;
		padding-left: 0;
		margin-bottom: 0;
	}
	.list-group-item:first-child {
		border-top-left-radius: .25rem;
		border-top-right-radius: .25rem;
	}
	.list-group-item {
		position: relative;
		display: block;
		padding: .75rem 1.25rem;
		margin-bottom: -1px;
		border: 1px solid rgba(0,0,0,.125);
	}
</style>



// WEBPACK FOOTER //
// src/components/user/account/bankAccountList.vue